  let savedScrollY = 0;
  let isLocked = false;

  function lockScroll() {
    if (isLocked) return;
    savedScrollY = window.scrollY;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${savedScrollY}px`;
    document.body.style.width = '100%';
    isLocked = true;
  }

  function unlockScroll() {
    if (!isLocked) return;
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, savedScrollY);
    isLocked = false;
  }

  function attachListeners() {
    const megaDetails = document.querySelector('#Details-HeaderMenu-1');
    const drawerContainer = document.querySelector('#Details-menu-drawer-container');

    if (!megaDetails && !drawerContainer) return false;

    if (megaDetails) {
      megaDetails.addEventListener('toggle', function () {
        if (megaDetails.hasAttribute('open')) {
          lockScroll();
        } else {
          unlockScroll();
        }
      });
    }

    if (drawerContainer) {
      drawerContainer.addEventListener('toggle', function () {
        if (!drawerContainer.hasAttribute('open')) {
          unlockScroll();
        }
      });
    }

    document.querySelectorAll('.menu-drawer__close-button').forEach(function (btn) {
      btn.addEventListener('click', unlockScroll);
    });

    return true;
  }

  if (!attachListeners()) {
    const observer = new MutationObserver(function () {
      if (attachListeners()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') unlockScroll();
  });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) unlockScroll();
  });
  (function () {
  function forceStickyHeader() {
    var header = document.querySelector('.section-header');
    if (!header) return;
    header.style.setProperty('position', 'sticky', 'important');
    header.style.setProperty('top', '0px', 'important');
    header.style.setProperty('z-index', '999', 'important');
  }

  // Fire on DOM ready
  document.addEventListener('DOMContentLoaded', forceStickyHeader);

  // Fire again after full load (catches late-running Dawn JS)
  window.addEventListener('load', forceStickyHeader);

  // One final delayed run as insurance
  window.addEventListener('load', function () {
    setTimeout(forceStickyHeader, 300);
  });
})();